"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "LabSyncStatusSchema", {
    enumerable: true,
    get: function() {
        return LabSyncStatusSchema;
    }
});
const _zod = require("zod");
const LabSyncStatusSchema = _zod.z.object({
    gatewayEnabled: _zod.z.boolean(),
    openQuarantineCount: _zod.z.number().int().min(0),
    filesRejectedCount: _zod.z.number().int().min(0),
    filesFailedCount: _zod.z.number().int().min(0),
    lastSuccessAt: _zod.z.string().datetime({
        offset: true
    }).nullable()
}).strict();
